import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Form, useForm } from 'react-hook-form';
import { z } from 'zod';
import { Button, Heading, List, Modal, Stack, Text } from 'xen-ui';
import { ErrorText, TextLink } from 'xen/components';
import { FormFileInput } from 'xen/components/form';
import { useSearchParamState } from 'xen/hooks';
/**
 * NOTE: This is all fake UI for the purpose demoing, behind the demoware feature flag.
 */
export const FactoringImportWizard = () => {
    const [importWizard, setImportWizard] = useSearchParamState('factoringImportWizard');
    const title = 'Import wizard';
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, { children: [_jsxs(Stack, { gap: "xxxs", children: [_jsx(Heading, { level: 2, children: "Historical data" }), _jsx(Text, { c: "dimmed", children: "Import historical data from other systems into XEN" })] }), _jsx(Button, { onClick: () => setImportWizard('true'), style: { alignSelf: 'flex-start' }, children: title })] }), _jsx(Modal, { onClose: () => setImportWizard(undefined), opened: importWizard === 'true', padding: "lg", size: "lg", title: title, children: _jsx(FactoringImportWizardModalContent, {}) })] }));
};
const FactoringImportWizardModalContent = () => {
    return (_jsxs(Stack, { children: [_jsx(Text, { children: "To import historical factoring data into XEN" }), _jsxs(List, { type: "ordered", withPadding: true, children: [_jsxs(List.Item, { children: [_jsx(TextLink, { searchParams: { factoringImportWizard: 'true' }, to: "/configurations/factoring", children: "Download" }), ' ', "the XEN templates"] }), _jsx(List.Item, { children: "Fill in information" }), _jsx(List.Item, { children: "Upload each as outlined below" }), _jsxs(List.Item, { children: ["Click ", _jsx("b", { children: "process" })] })] }), _jsx(FactoringImportWizardForm, {})] }));
};
const FactoringImportWizardSchema = z
    .object({
    clients: FormFileInput.schema({ required: false }).nullable(),
    debtors: FormFileInput.schema({ required: false }).nullable(),
    rateTables: FormFileInput.schema({ required: false }).nullable(),
    purchases: FormFileInput.schema({ required: false }).nullable(),
    payments: FormFileInput.schema({ required: false }).nullable(),
    reserveActivity: FormFileInput.schema({ required: false }).nullable(),
    // Only used for form-wide validation errors
    // https://github.com/orgs/react-hook-form/discussions/7111
    generalError: z.string().optional(),
})
    .refine((data) => Object.values(data).some((val) => !!val), {
    message: 'At least one file must be uploaded for processing',
    path: ['generalError'],
});
const FactoringImportWizardForm = () => {
    const { control, clearErrors, formState } = useForm({
        resolver: zodResolver(FactoringImportWizardSchema),
        mode: 'onBlur',
        defaultValues: {
            clients: null,
            debtors: null,
            rateTables: null,
            purchases: null,
            payments: null,
            reserveActivity: null,
        },
    });
    const { errors } = formState;
    const fieldProps = {
        clearable: true,
        control,
        onChange: (value) => {
            value && clearErrors();
        },
        required: true,
    };
    return (_jsx(Form, { control: control, children: _jsxs(Stack, { gap: "lg", children: [_jsxs(Stack, { gap: "xs", children: [_jsx(FormFileInput, { ...fieldProps, label: "Clients", name: "clients" }), _jsx(FormFileInput, { ...fieldProps, label: "Debtors", name: "debtors" }), _jsx(FormFileInput, { ...fieldProps, label: "Rate tables", name: "rateTables" }), _jsx(FormFileInput, { ...fieldProps, label: "Purchases", name: "purchases" }), _jsx(FormFileInput, { ...fieldProps, label: "Payments", name: "payments" }), _jsx(FormFileInput, { ...fieldProps, label: "Reserve activity", name: "reserveActivity" })] }), errors?.generalError?.message && _jsx(ErrorText, { message: errors.generalError.message }), _jsx(Button, { disabled: true, style: { alignSelf: 'flex-start' }, type: "submit", children: "Process" }), _jsx(Text, { c: "dimmed", size: "sm", children: "Note: may take several hours to complete" })] }) }));
};
